import { styled } from '@ori-ui/mui';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useSWRConfig } from 'swr';

import { useStepperData, useConfiguration } from '../../contexts';
import { Stepper } from '../Stepper';
import { LegalStep, PersonalStep, SponsorStep } from '../Steps';

const RootContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

const ContentContainer = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '500px',
}));

interface IStepContentProps {
  currentStep?: string;
  steps: string[];
}

export const StepperWithContent: FC<IStepContentProps> = (props) => {
  const { currentStep, steps } = props;
  const {
    context: { stepperData },
  } = useStepperData();
  const { activeStep, setActiveStep, setStepsOrder } = stepperData;
  const { registrationType, referral } = useConfiguration();

  const { cache } = useSWRConfig();

  const isVipCustomerType = registrationType === 'VipCustomer';
  const isCorrectReferral = referral?.ReferralType === 'Pbs' || referral?.ReferralType === 'ReferralLink';

  const vipWithoutSponsor = isVipCustomerType && !isCorrectReferral;

  useEffect(() => {
    setStepsOrder(steps);
  }, [setStepsOrder, steps]);

  useEffect(() => {
    if (currentStep) {
      const actualStep = steps.indexOf(currentStep);

      if (actualStep !== -1) {
        setActiveStep(actualStep);
        cache.delete('registrationData');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed other property
  }, [currentStep]);
  const getStepperContent = () => {
    let content;
    switch (activeStep) {
      case 0:
        content = (
          <ContentContainer>
            <PersonalStep />
          </ContentContainer>
        );
        break;
      case 1:
        content = <ContentContainer>{vipWithoutSponsor ? <LegalStep /> : <SponsorStep />}</ContentContainer>;
        break;
      case 2:
        content = (
          <ContentContainer>
            <LegalStep />
          </ContentContainer>
        );
        break;
      default:
        content = null;
    }

    return content;
  };

  const stepperContent = getStepperContent();

  return (
    <RootContainer>
      <Stepper
        canChangeStep={false}
        steps={steps}
        visibleLables={false}
      />
      {stepperContent}
    </RootContainer>
  );
};
